export default __webpack_public_path__ + "static/media/slide1.30e9b4e2.jpg";